import { onPath } from '../utils/path';
import { selectMany, addClass, removeClass } from '../utils/dom-utils';
import * as basicLightbox from 'basiclightbox';
import hljs from 'highlight.js/lib/highlight';
import javascript from 'highlight.js/lib/languages/javascript';

hljs.registerLanguage('javascript', javascript);

onPath('/help/*', () => {

  var pageName;

  if(document.head.querySelector) {
    var metaTag = document.head.querySelector("meta[name=pageName]");
    if(metaTag) {
      pageName = metaTag.content;
    }
  };

  const helpVoteYes = selectMany('.article-helpful-yes');
  const helpVoteNo = selectMany('.article-helpful-no');

  helpVoteYes.forEach(function (el, i) {
    el.addEventListener('click', (evt) => {
      helpVoteNo.forEach(function (ell, i) {
        // disable opposite
        addClass(ell,"opposite-clicked");
        removeClass(ell,"clicked");
      });

      helpVoteYes.forEach(function (ell, i) {
        // disable opposite
        addClass(ell,"clicked");
        removeClass(ell,"opposite-clicked");
      });
      // fire event
      analytics.track("Viewed " + pageName, {helpful: 'yes' });
      analytics.track("Rated Help Article", {helpful: 'yes', pageName: pageName, path: document.location.pathname });
    });
  });

  helpVoteNo.forEach(function (el, i) {
    el.addEventListener('click', (evt) => {
      helpVoteYes.forEach(function (ell, i) {
        // disable opposite
        addClass(ell,"opposite-clicked");
        removeClass(ell,"clicked");
      });

      helpVoteNo.forEach(function (ell, i) {
        // disable opposite
        addClass(ell,"clicked");
        removeClass(ell,"opposite-clicked");
      });
      // fire event
      analytics.track("Viewed " + pageName, {'helpful' : 'no' });
      analytics.track("Rated Help Article", {helpful: 'no', pageName: pageName, path: document.location.pathname });
    });
  });




  /*
    Image lightbox
    Wraps each image in a <figure> element and loads lightbox on click
  */


  const images = selectMany('.article-body img');

  images.forEach(function (el, i) {

    el.addEventListener('click', (evt) => {

      const lightboxImgWrapper = document.createElement('figure');
      const lightboxImg = el.cloneNode(true);
      lightboxImgWrapper.appendChild(lightboxImg);

      const instance = basicLightbox.create(lightboxImgWrapper);
      instance.show();

    });

  });

  /*
    hightlight.js syntax highlighter
    Finds and highlights code inside `<pre><code>` tags
    https://github.com/highlightjs/highlight.js#getting-started
  */

  hljs.initHighlightingOnLoad();

});
